(function () {
  const productsFilters = () => {
    const products = document.querySelectorAll('.collection-popular-card');
    const limit = document.querySelector('.popular-products__wrapper').dataset.limit;

    document.querySelectorAll('.filters__item').forEach(item => {      
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const typeTarget = item.dataset.typeTarget;
        document.querySelectorAll('.filters__item').forEach(element => {
          element.classList.remove('filters__item_active');
        })
        item.classList.add('filters__item_active');

        let i = 0;
        products.forEach(element => {
          let productType = element.dataset.type;
          if ((productType == typeTarget || typeTarget == "all") && i < limit) {
            element.classList.add('show');
            i++;
          }
          else {
            element.classList.remove('show');
          }
        });
      })
    })
  }

  productsFilters();

  document.addEventListener('shopify:section:load', function () {
		productsFilters();
	});
})();

(function () {
  const initScroller = () => {
    document.querySelectorAll('[data-popular-products-nav]').forEach((nav) => {
      if (nav.dataset.scrollerBound === 'true') return;
      nav.dataset.scrollerBound = 'true';

      const root = nav.closest('.popular-products');
      if (!root) return;
      const list = root.querySelector('.popular-products__wrapper');
      const prev = nav.querySelector('[data-popular-products-prev]');
      const next = nav.querySelector('[data-popular-products-next]');
      const scrollbar = nav.querySelector('[data-popular-products-scrollbar]');
      const drag = nav.querySelector('[data-popular-products-scrollbar-drag]');
      if (!list || !prev || !next) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const getStep = () => {
        const card = list.querySelector('.collection-popular-card.show, .collection-popular-card--placeholder');
        if (!card) return list.clientWidth;
        const styles = window.getComputedStyle(list);
        const gap = parseFloat(styles.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const updateNav = () => {
        const maxScroll = list.scrollWidth - list.clientWidth;
        nav.classList.toggle('is-hidden', maxScroll <= 1);
        prev.disabled = list.scrollLeft <= 1;
        next.disabled = list.scrollLeft >= maxScroll - 1;

        if (scrollbar && drag && list.scrollWidth > 0) {
          const trackWidth = scrollbar.clientWidth;
          const ratio = list.clientWidth / list.scrollWidth;
          const dragWidth = Math.min(Math.max(trackWidth * ratio, 24), trackWidth);
          const position = maxScroll > 0 ? (list.scrollLeft / maxScroll) * (trackWidth - dragWidth) : 0;
          drag.style.width = `${dragWidth}px`;
          drag.style.transform = `translateX(${position}px)`;
        }
      };

      const scrollByStep = (direction) => {
        list.scrollBy({
          left: direction * getStep(),
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
        });
      };

      prev.addEventListener('click', () => scrollByStep(-1));
      next.addEventListener('click', () => scrollByStep(1));
      list.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);

      root.querySelectorAll('.filters__item').forEach((item) => {
        item.addEventListener('click', () => window.requestAnimationFrame(updateNav));
      });

      if (scrollbar && drag) {
        let dragging = false;
        let startX = 0;
        let startScrollLeft = 0;

        drag.addEventListener('pointerdown', (event) => {
          const trackWidth = scrollbar.clientWidth;
          const dragWidth = parseFloat(drag.style.width) || trackWidth;
          if (trackWidth - dragWidth <= 0) return;
          dragging = true;
          startX = event.clientX;
          startScrollLeft = list.scrollLeft;
          drag.setPointerCapture(event.pointerId);
        });
        drag.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          const maxScroll = list.scrollWidth - list.clientWidth;
          const trackWidth = scrollbar.clientWidth;
          const dragWidth = parseFloat(drag.style.width) || trackWidth;
          if (maxScroll <= 0 || trackWidth - dragWidth <= 0) return;
          const delta = event.clientX - startX;
          list.scrollLeft = startScrollLeft + (delta / (trackWidth - dragWidth)) * maxScroll;
        });
        const stopDragging = () => {
          dragging = false;
        };
        drag.addEventListener('pointerup', stopDragging);
        drag.addEventListener('pointercancel', stopDragging);
      }

      updateNav();
    });
  };

  document.addEventListener('DOMContentLoaded', initScroller);
  document.addEventListener('shopify:section:load', initScroller);
})();